module.exports = __webpack_public_path__ + "kameon-icons.59f5f84bfd6b56a8fa86.svg";


//////////////////
// WEBPACK FOOTER
// C:/GIT/kameon.gdpr/ui/src/assets/fonts/kameon-icons.svg?v=0.1.0
// module id = ../../../../../src/assets/fonts/kameon-icons.svg?v=0.1.0
// module chunks = styles